// extracted by mini-css-extract-plugin
export default {"Modal":"Modal_Modal__Ezlc6","ModalWide":"Modal_ModalWide__mP-A6"};